export interface IUncoveredShortfallSpecifications {
    applyUncoveredShortfall?: boolean;
    uncoveredShortfallAssetsFli?: string;
    uncoveredShortfallLiabilitiesFli?: string;
    uncoveredShortfallAssetsFliCaption: string;
    uncoveredShortfallEquityFliCaption: string;
    uncoveredShortfallAssetsAccountName: string;
    uncoveredShortfallEquityAccountName: string;
}
